import { EdgeLoadHuntTypesWithActivityRepository } from '@/shared/infra/repositories'
import { makeSupabaseEdgeHttpClient } from '@/main/factories/http'
import type { LoadHuntTypesWithActivity } from '@/shared/domain'

export function makeLoadHuntTypesWithActivity(): LoadHuntTypesWithActivity {
  return new EdgeLoadHuntTypesWithActivityRepository(makeSupabaseEdgeHttpClient()).execute
}
